export default "__VITE_ASSET__s5B$_hKd__"